import * as React from "react";

import { cn } from "@/lib/utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "flex field-sizing-content min-h-16 w-full rounded-md border border-line-3 bg-transparent px-2 py-1.5 text-base text-fg transition-colors duration-100 outline-none placeholder:text-fg-4 focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-primary/40 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-danger-line aria-invalid:focus-visible:ring-danger/30",
        className
      )}
      {...props}
    />
  );
}

export { Textarea };
